<template>
    <div
		class="date-picker-container"
		:class="{
			'active' : isActive,
			'has-error': hasError,
			'time':options.type==='time',
			'date':options.type==='date',
			'disabled': disabled
		}"
	>
        <label v-if="label">
			{{label}}
		</label>

        <date-picker
			v-model="selected"
            class="picker"
            ref="inputText"
            lang="en"
            input-class="input-field"
            :type="options.type"
            :format="options.format"
			:range="options.range"
            :placeholder="options.placeholder"
            :not-before="options.notBefore"
            :not-after="options.notAfter"
			:clearable="clearable"
			:editable="options.editable"
			:minute-step="10"
            @input="update()"
			@clear="clear()"
			@panel-change="onPanelChange($event)"
        >
			<div slot="header" class="picker-header" v-if="options.range">
				<p>From</p>
				<p>To</p>
			</div>
        </date-picker>

        <div class="helper-text" v-if="helperText">
			{{ helperText }}
		</div>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker'
export default {
	props: {
		options: {
			type: Object,
			default: () => {
				return {
					type: 'date',
					format: 'YYYY/MM/DD',
					placeholder: 'YYYY/MM/DD',
					range: false,
					notBefore: undefined,
					notAfter: undefined,
					editable: false
				}
			}
		},

		value: {
			default: null
		},

		hasError: {
			type: Boolean,
			default: false
		},

		clearable: {
			type: Boolean,
			default: true
		},

		helperText: {
			type: String,
			default: null
		},

		label: {
			type: String,
			default: ''
		},

		disabled: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
			selected: null,
			isActive: false,
			isInTimePanel: false,
			isInDatePanel: false,
			temporaryTime: null,
			temporaryTimeArr: []
		}
	},

	mounted () {
		this.selected = this.value
	},

	watch: {
		value (val) {
			this.selected = val

			if (val) {
				this.update()
			}
		}
	},

	components: {
		DatePicker
	},

	methods: {
		onPanelChange (e) {
			this.isInTimePanel = e.toLowerCase() === 'time'
			this.isInDatePanel = e.toLowerCase() === 'date'
			this.$emit('onPanelChange', e)
		},

		focus () {
			this.isActive = true
		},

		blur () {
			this.isActive = false
		},

		update () {
			if (this.disabled) {
				this.selected = ''
				return
			}

			this.$emit('input', this.selected)

			// logic to close popup with time and time-range
			if (this.isInTimePanel && this.options.type.indexOf('time') > -1) {
				if (!this.options.range) {
					if (this.temporaryTime === null) {
						this.temporaryTime = new Date(this.selected).getMinutes()
					}

					if (this.temporaryTime !== new Date(this.selected).getMinutes()) {
						this.$refs.inputText.closePopup()
					}
				} else {
					if (this.temporaryTimeArr.length === 0) {
						this.selected.forEach(item => {
							this.temporaryTimeArr.push(item.getMinutes())
						})
					}

					for (let [key, time] of this.temporaryTimeArr.entries()) {
						if (time !== this.selected[key].getMinutes()) {
							this.$refs.inputText.closePopup()
							break
						}
					}
				}
			}

			// logic to close popup date range
			if (this.isInDatePanel && this.options.range) {
				this.$refs.inputText.closePopup()
			}
		},

		clear () {
			this.selected = null
			this.$emit('clear', this.selected)
		},

		clearDate () {
			this.$refs.inputText.clearDate()
		}
	}
}
</script>
<style lang="scss" scoped>
.date-picker-container {
	cursor: pointer;
	position: relative;
	display: flex;
    flex-direction: column;
    justify-content: flex-end;

	label {
		text-align: left;
		font-weight: 400;
		font-size: 13px;
		font-size: 16px;
		color: #575B5C;
		pointer-events: none;
		padding: 10px 0;
		width: 100%;
		height: 39px;
		display: flex;
		align-items: flex-end;
    }

    /deep/ .mx-datepicker {
        width: 100%;

		.mx-input-wrapper:first-child {
			margin-right: 0;
		}
    }

	/deep/ .input-field {
		cursor: pointer;
		display: block;
		text-align: left;
		width: 100%;
		outline: none;
		font-size: 16px;
		color: #4A4C50;
		border: none;
		transition: height 0.3s ease;
	}

	.helper-text {
		display: block;
		text-align: left;
		font-size: 13px;
		pointer-events: none;
		color: #808495;
	}

	/deep/  .input-field {
		border: 1px solid #C6C6C6;
		border-radius: 4px;
		font-size: 13px;
		padding: 10px;
		padding-right: 28px;

		&::placeholder {
			color: #CECFD0;
			font-size: 13px;
		}
	}

	&:hover {
		/deep/  .input-field {
			border: 1px solid #2DC4B6;
		}

		label {
			color: #2DC4B6;
		}
	}

	&.disabled {
		opacity: 0.5;
		pointer-events: none;

		label {
			pointer-events: none;
			color: #575B5C;
		}
	}

	&.active{

		label {
			color: #2DC4B6;
		}

		/deep/  .input-field {
			border: 1px solid #2DC4B6;
		}
	}

	&.has-error {
		/deep/  .input-field {
			border: 1px solid #E71D36;
		}

		label,.helper-text {
			color: #E71D36;
		}
	}

	&.time {
		/deep/ .mx-calendar-header {
			display: none;
		}

		/deep/ .mx-shortcuts-wrapper {
			display: none;
		}
	}

	&.date {
		/deep/ .mx-shortcuts-wrapper {
			display: none;
		}
	}

	/deep/ .mx-datepicker-popup {
		.picker-header {
			display: flex;

			p {
				flex: 1 1 auto;
				text-align: center;
				color: #2DC4B6;
			}
		}
	}
}

</style>
